import { memo } from "react";
import Box from "@mui/material/Box";

const Divider = () => {
    const circle = (
        <Box
            sx={{
                height: 10,
                width: 10,
                borderRadius: '50%',
                borderWidth: 2,
                borderStyle: 'solid',
                borderColor: 'text.secondary'
            }}
        />
    );

    return (
        <Box
            sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            {circle}
            <Box
                sx={{
                    flexGrow: 1,
                    height: 2,
                    bgcolor: 'text.secondary'
                }}
            />
            {circle}
        </Box>
    );
};

export default memo(Divider);
